
export default {
  name: 'MonitorList',
  data() {
    return {
      // 监控api列表
      monitorApiList: [
        [
          {
            title: '监控列表',
            api: 'tasklist'
          },
          {
            title: '添加任务',
            api: 'taskadd'
          },
          {
            title: '修改任务',
            api: 'taskedit'
          },
          {
            title:'获取检测API接口',
            api:'apiinterface/apilist'
          }
        ],
        [
          {
            title: '启用全部',
            api: 'allstart'
          },
          {
            title: '启动选中',
            api: 'selectstart'
          },
          {
            title: '启动正常',
            api: 'startnormal'
          },
          {
            title: '启动异常',
            api: 'startabnormal'
          },
          {
            title: '启动未知',
            api: 'start_unknown'
          }
        ],
        [
          {
            title: '开启自动停用',
            api: 'abnormalstart'
          },
          {
            title: '关闭自动停用',
            api: 'abnormalstop'
          }
        ],
        [
          {
            title: '删除全部任务',
            api: 'delall'
          },
          {
            title: '删除选中任务',
            api: 'selectdel'
          },
          {
            title: '删除正常任务',
            api: 'delnormal'
          },
          {
            title: '删除异常任务',
            api: 'delabnormal'
          },
          {
            title: '删除启用任务',
            api: 'delstart',
          },
          {
            title: '删除停用任务',
            api: 'delstop'
          },
          {
            title: '删除未知任务',
            api: 'del_unknown'
          },
          {
            title: '删除过期任务',
            api: 'del_overdue'
          }
        ],
        [
          {
            title: '停用全部',
            api: 'allstop'
          },
          {
            title: '停用选中',
            api: 'selectstop'
          },
          {
            title: '停用正常',
            api: 'stopnormal'
          },
          {
            title: '停用异常',
            api: 'stopabnormal'
          },
          {
            title: '停用未知',
            api: 'stop_unknown'
          }
        ]
      ],
      activeName: this.$route.query.fold,
    }
  }
}
